import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Box } from 'foundations-components/transitional/components/Box';
import { Section } from 'foundations-components/transitional/components/Section';
import { AsyncStatus } from 'reporting-data/asyncData/AsyncStatus';
import { ANALYST, DIGEST } from 'reporting-data/constants/aiSettings';
import AILoadingPills from '../../../../shared/AILoadingPills';
import { useEffect, useState } from 'react';
import usePrevious from 'react-utils/hooks/usePrevious';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const numPillsByStyle = {
  [ANALYST]: 10,
  [DIGEST]: 4
};
const DEFAULT_NUM_PILLS = 6;
export function AISettingsPreview({
  summaryStyle,
  insight,
  insightStatus,
  resetInsightStatus
}) {
  const [numPills, setNumPills] = useState(DEFAULT_NUM_PILLS);
  const prevInsightStatus = usePrevious(insightStatus);
  useEffect(() => {
    if (insightStatus === AsyncStatus.STARTED && prevInsightStatus !== AsyncStatus.STARTED) {
      setNumPills(summaryStyle ? numPillsByStyle[summaryStyle] : DEFAULT_NUM_PILLS);
    }
  }, [insightStatus, summaryStyle, prevInsightStatus]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "heading-50",
      marginBlockStart: "50",
      paddingBlockStart: "200",
      paddingBlockEnd: "100",
      children: I18n.text('reporting-enablement.aiInsightsSettings.preview')
    }), insightStatus === AsyncStatus.FAILED && /*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(Alert, {
        type: "danger",
        closeable: true,
        onClose: resetInsightStatus,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-enablement.aiInsightsSettings.error"
        })
      })
    }), /*#__PURE__*/_jsx(Flex, {
      "aria-live": "alert",
      backgroundColor: "fill-surface-recessed",
      padding: "200",
      borderRadius: "100",
      marginBlockEnd: "600",
      inlineSize: "100%",
      flexGrow: 1,
      overflowY: "auto",
      maxBlockSize: "474px",
      children: insightStatus === AsyncStatus.STARTED ? /*#__PURE__*/_jsx(Box, {
        inlineSize: "100%",
        role: "presentation",
        "data-test-id": "ai-settings-preview-loading",
        children: /*#__PURE__*/_jsx(AILoadingPills, {
          rows: numPills
        })
      }) : insight
    })]
  });
}